import { isNull } from "lodash";
import { useAuth } from "./useAuth";
import { AuthContext } from "~/Types";

export const useHasAccess = () => {
  const { user } = useAuth();

  const hasPermissions = (roles: string[]) => {
    const currentUser:any = JSON.parse(localStorage.getItem("user") || "{}");

    if (isNull(currentUser)) {
      return false;
    }
    if (roles[0] === "*") {
      return true;
    } else {
      return currentUser?.access?.some((permissionName:any) => Boolean(roles.includes(permissionName)));
    }
  };

  const hasRole = (roles: string[]) => {
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

    if (isNull(currentUser)) {
      return false;
    }
    if (roles[0] === "*") {
      return true;
    } else {
      return Boolean(roles.includes(currentUser.role));
    }
  };

  return {
    hasPermissions,
    hasRole,
  };
};

